import onRequest from './onRequest'
import onResponse from './onResponse'
import axios from 'axios'
import { getLocal } from '../cache'
import { getUserI18n } from '@/util/tools.js'

const AXIOS_INSTANCE = axios.create({
  baseURL: process.env.VUE_APP_QMOVE,
  headers: {
    'User-I18n': getUserI18n()
  }, // 每个请求要携带的头
  timeout: 0, // 不设置超时
  silent: false, //不提示
  withCredentials: true, // 跨域带cookies, 会让简单请求变为复杂请求, 一般根据后端需要配置
  trimNull: false, // 是否去除空值
  ignoreCode: false, // 是否忽略服务端的错误提示
  toXss: true,
  thaadAccessKey: false,
  notWithWorkBenchId: false
})

onRequest(AXIOS_INSTANCE)
onResponse(AXIOS_INSTANCE)
/**
 *
 * @param {*} url
 * @param {*} option axios的配置项,有以下自定义扩展选项
 * - useLocal [String] 本地缓存的键
 *    是否启用本地缓存, 默认为1小时, 即1小时内有同个键的请求都走取本地缓存
 *    如 city_area 等大量又不常改动的数据
 *
 * - single [Boolean|String] 启用单例模式
 *    即每次该url请求都会取消掉上一个同样url的请求,保证同一时间只有一个生效
 *    值为boolean则以url为 键
 *
 * - getter [Object]定义该次请求从哪些字段取值
 *    successCode 接口成功验证值
 *    code 获取接口状态
 *    message 获取错误信息
 *    data 成功的返回值，不为string 则返回完整response.data值

  形如     option: {
            getter:{
              successCode: 200,
              code: 'respCode.code',
              message: 'respCode.message',
              data: 'data'
            }
          }
  意义为:  从后端返回结果
          验证 respCode.code, 当值为200时表示请求成功
          取 respCode.message 作为提示信息
          取 data 作为接口成功返回值
 */
/*
以权限系统为例, 完整请求如下
import request from "@/plugins/request";
const data = await request(
  `//dev-pm.amh-group.com/perm/exportV2/queryMenuTree`,
  {
    method: "GET",
    getter: {
      successCode: 200,
      data: "data",
      code: "code",
      message: "message"
    },
    params: {
      category: "data",
      flag: "0"
    }
  }
);
其成功的接口返回为:
response.data:
  code: 200,
  data: [ ... ],
  message: ''
data即为成功后返回的权限列表
 */

const defaultGetter = {
  successCode: 1,
  code: 'result',
  message: 'errorMsg',
  data: 'data',
  info: 'info'
}
export default function(url, option) {
  option = option || {}
  if (option.useLocal) {
    const data = getLocal(option.useLocal)
    if (data) {
      return data
    }
  }
  assignGetter(option)
  return AXIOS_INSTANCE(url, option)
}

function assignGetter(option) {
  const getter = option.getter
  if (!getter) {
    option.getter = defaultGetter
    return option.getter
  }
  ;['code', 'message', 'data', 'info'].forEach(key => {
    if (!getter[key]) {
      getter[key] = defaultGetter[key]
    }
  })
}
